<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-form-select-input
                    :options="venues"
                    v-model="venueId"
                ></app-form-select-input>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-mail-filters
                    @filter="onFilter"
                    :venue="venue"
                ></app-mail-filters>
            </b-col>
        </b-row>
        <b-row class="my-2" v-if="venueSelected">
            <b-col cols="12" md="4">
                <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="exportMails"
                    :disabled="!venueSelected"
                >
                    <i class="fa fa-download" aria-hidden="true"></i> Exportar
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-mails-list
                    v-if="venueSelected"
                    :the-client="client"
                    :venue="venue"
                    ref="mails-list"
                ></app-mails-list>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import appMailFilters from './MailFilters'
import appMailsList from './MailList'
export default {
    components: {
        appMailFilters,
        appMailsList,
    },
    data: () => ({
        venues: [],
        venueId: '',
        currentFilters: null,
    }),
    computed: {
        venueSelected() {
            return !!this.venueId
        },
        venue() {
            return this.venues.find(item => item.id === this.venueId)
        },
    },
    methods: {
        onFilter(filters) {
            this.currentFilters = filters
            this.$refs['mails-list'].refresh(filters)
        },
        exportMails() {
            if (!this.client || !this.client.id) {
                toastr.error('No hay cliente seleccionado')
                return
            }
            if (!this.venueSelected || !this.venue) {
                toastr.error('Seleccione una sede')
                return
            }
            const params = {
                client: this.client.id,
                venue: this.venue.id,
                sortBy: 'mails.created_at',
                sortDir: 'desc',
            }
            const f = this.currentFilters
            if (f) {
                if (f.type !== '' && f.type != null) params.type = f.type
                if (f.destination) params.destination = f.destination
                if (f.owner) params.owner = f.owner
                if (f.deliveredTo) params.deliveredTo = f.deliveredTo
                if (f.delivered !== '' && f.delivered != null) {
                    params.delivered = String(f.delivered)
                }
            }
            const queryString = Object.keys(params)
                .map(
                    k =>
                        `${encodeURIComponent(k)}=${encodeURIComponent(
                            params[k]
                        )}`
                )
                .join('&')
            window.location.href = `exports/mail/export-excel?${queryString}`
        },
        async loadVenues() {
            const { data } = await repo.get(`clients/${this.client.id}/venues`)
            this.venues = data
            if (this.venues.length !== 1) return
            this.venueId = this.venues[0].id
        },
    },
    created() {
        this.loadVenues()
    },
}
</script>
